import { QuotaWithInfoAgg } from '../types/quotaWithInfoAgg';

export const isQuotaPlayable = (isDisabled: boolean, quota?: number | QuotaWithInfoAgg): quota is QuotaWithInfoAgg => {
  return !isDisabled;
};

export const getQuotaValue = (isDisabled: boolean, quota?: number | QuotaWithInfoAgg | undefined) => {
  if (quota) {
    return isQuotaPlayable(isDisabled, quota) ? quota.value : quota;
  }
  return undefined;
};

export const getQuotaFissaValue = (isDisabled: boolean, quota: number | undefined) => {
  if (quota && isDisabled && quota !== 100) {
    return quota;
  } else {
    return;
  }
};
